import { render, staticRenderFns } from "./GalleryWrapper.vue?vue&type=template&id=96b8480c&scoped=true"
import script from "./GalleryWrapper.vue?vue&type=script&lang=ts"
export * from "./GalleryWrapper.vue?vue&type=script&lang=ts"
import style0 from "./GalleryWrapper.vue?vue&type=style&index=0&id=96b8480c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b8480c",
  null
  
)

export default component.exports